export default function Layout({ children }: any) {
  return (
    <div className="w-screen h-screen bg-gray-50 overflow-hidden main-bg flex justify-center">
      <div className="w-full md:w-3/4 lg:w-4/5 bg-white h-screen overflow-x-hidden overflow-y-hidden shadow-lg m-2">
        {children}
      </div>
    </div>
  );
}
